import { cx } from '@emotion/css';
import { type FC, useRef } from 'react';

import { MotifComponent, useMotifStyles } from '../../motif';
import type { BaseComponentProps } from '../../types';
import type { Animation } from '../Animations';
import { useAnimations } from '../Animations';
import { statCss, statsContainerCss, supplementaryTextCss } from './Stats.styled';

export interface StatsProps extends BaseComponentProps {
  stat: string;
  optionalSupplementaryText?: string;
  animation?: Animation;
}

export const Stats: FC<StatsProps> = ({ stat, optionalSupplementaryText, animation, style }) => {
  useMotifStyles(MotifComponent.STATS);

  const statsRef = useRef(null);
  const animationCssProps = useAnimations(statsRef, animation);

  return (
    <figure
      ref={statsRef}
      className={cx(MotifComponent.STATS, statsContainerCss)}
      style={{ ...animationCssProps, ...style }}
    >
      <span className={statCss}>{stat}</span>
      {optionalSupplementaryText && (
        <span className={supplementaryTextCss}>{optionalSupplementaryText}</span>
      )}
    </figure>
  );
};

Stats.displayName = 'Stats';
